import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import * as getters from './getters'

Vue.use( Vuex );


const state = {
    TouchScreen:false,
  CountTime:10
}

//一個 module 僅可以有一個 default export。

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters,

    // 嚴格模式，禁止直接修改 state
    strict: true
});

